import { apiClient } from '@shared/utils/api-client';

export interface SellerNotificationItem {
  id: number;
  category: string;
  title: string;
  body: string | null;
  status: 'UNREAD' | 'READ';
  data: unknown;
  createdAt: string;
}

export interface SellerNotificationsResponse {
  items: SellerNotificationItem[];
  total: number;
}

export const sellerNotificationsApi = {
  getUnreadCount: () => apiClient.get<{ count: number }>('/seller-notifications/me/unread-count'),

  list: async (params?: { limit?: number; offset?: number; unreadOnly?: boolean }) => {
    const search = new URLSearchParams();
    if (params?.limit != null) search.set('limit', String(params.limit));
    if (params?.offset != null) search.set('offset', String(params.offset));
    if (params?.unreadOnly === true) search.set('unreadOnly', 'true');
    const q = search.toString();
    return apiClient.get<SellerNotificationsResponse>(
      `/seller-notifications/me${q ? `?${q}` : ''}`,
    );
  },

  markRead: (id: number) => apiClient.patch<{ ok: boolean }>(`/seller-notifications/me/${id}/read`, {}),

  markAllRead: () => apiClient.patch<{ ok: boolean }>('/seller-notifications/me/read-all', {}),
};
